export const en = {
    'add-creatives': {
        one: 'Add this creative format to expand your audience: {formats}',
        some: 'Add these creative formats to expand your audience: {formats}',
        many: 'Add these creative formats to expand your audience: {formats}',
        none: ''
    },
    close: 'Close',
    title: 'Add creatives in matching formats',
    'title-hint': "You are seeing this recommendation because the ad group doesn't have complete coverage"
};
